export default "https://cdn-shared.mathletics.com/teacher-modules/mathletics-library/38/assets/images/arrow-left.175342f1c1a4ebe39599fd3f89ad3455.svg";